module.exports = __webpack_public_path__ + "img/vk-v.3230964a.svg";